import { ChevronDown, ChevronUp, Pencil } from 'lucide-react';
import React, { useState } from 'react';
import { Card } from '../shadcn-ui/card';
import formatDateTime from '@/lib/format-date-time';
import MediaGrid from '../sharedComponents/MediaGrid';

const ProcessCheckCard = ({ check, idx, setEditingCheck, setDrawerOpen }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Card key={check._id} className="grid grid-cols-[1fr_max-content] p-4">
      <div className="flex flex-col gap-1 text-sm">
        <div className="font-medium">
          {idx + 1}. {formatDateTime(check.time_of_check)}
        </div>
        {!isExpanded ? (
          <div className="flex flex-wrap items-center gap-2 leading-3">
            <div className="flex items-center gap-1">
              <div className="font-medium">Was coffee turned?</div>
              <div className="font-normal">{check.was_coffee_turned ? 'Yes' : 'No'}</div>
            </div>
            {check.ph_value && (
              <div className="flex">
                <div className="mr-2">•</div>
                <div className="font-medium">pH:&nbsp;</div>
                <div className="font-normal">{check.ph_value}</div>
              </div>
            )}
            {check.temperature && (
              <div className="flex">
                <div className="mr-2">•</div>
                <div className="font-medium">Temp:&nbsp;</div>
                <div className="font-normal">{check.temperature}°C</div>
              </div>
            )}
            {check.notes && (
              <div className="flex">
                <div className="mr-2">•</div>
                <div className="font-medium">Notes:&nbsp;</div>
                <div className="font-normal">{check.notes}</div>
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-col text-[#383838]">
            <div className="flex items-center gap-1 text-sm">
              <div className="font-medium">Was coffee turned:</div>
              <div className="font-normal">{check.was_coffee_turned ? 'Yes' : 'No'}</div>
            </div>
            {check.ph_value && (
              <div className="flex items-center gap-1 text-sm">
                <div className="font-medium">pH:</div>
                <div className="font-normal">{check.ph_value}</div>
              </div>
            )}
            {check.temperature && (
              <div className="flex items-center gap-1 text-sm">
                <div className="font-medium">Temp:</div>
                <div className="font-normal">{check.temperature}°C</div>
              </div>
            )}
            {check.notes && (
              <div className="flex items-center gap-1 text-sm">
                <div className="font-medium">Notes:</div>
                <div className="font-normal">{check.notes}</div>
              </div>
            )}
            {check?.media && (
              <div className='mt-1'>
                <MediaGrid media={[...check?.media]} remove={false} />
              </div>
            )}
          </div>
        )}
      </div>
      <div className="flex items-start gap-2">
        <button
          onClick={() => {
            setEditingCheck(check);
            setDrawerOpen(true);
          }}
        >
          <Pencil className="h-[18px] w-[18px]" />
        </button>
        <button onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </button>
      </div>
    </Card>
  );
};

export default ProcessCheckCard;
